<template>
  <div class="member-equity-create">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="100px">
      <el-form-item label="权益名称" prop="grade">
        <el-input v-model="form.name" placeholder="请输入权益名称" class="input" />
      </el-form-item>
      <el-form-item label="权益图片" prop="logo">
        <UploadImg @getUploadFile="getUploadFile" :uploadUrl="form.logo" :desc="'建议：上传80*80的jpg、 png的图片'"></UploadImg>
      </el-form-item>
      <el-form-item label="权益详情" prop="remark">
        <el-input type="textarea" rows="6" v-model="form.remark" placeholder="请输入权益详情" show-word-limit />
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSubmit" class="fun-btn">确定</el-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import { api_putMemberBenefit, api_postMemberBenefit, api_getMemberBenefit } from '@/api/member'
import { api_postFileUpload } from '@/api/common'
export default {
  name: "mEquityCreate",
  components: {
    UploadImg
  },
  data() {
    return {
      form: {
        logo: '',
        remark: '',
        name: ''
      },
      rules: {
        logo: [{ required: true, message: '请上传等级LOGO' }],
        remark: [{ required: true, message: '请输入权益详情' }],
        name: [{ required: true, message: '请输入权益名称' }],
      },
      submitLoading: false
    };
  },
  created() {
    if (this.$route.query.id) {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">会员管理/会员权益<span class="black">/编辑权益</span></span>'
      this.getInfo()
    } else {
      this.$route.meta.breadcrumbTitle = '<span class="noblack">会员管理/会员权益<span class="black">/创建权益</span></span>'
    }
  },
  methods: {
    // 获取详情数据
    async getDetailDate() {
    },
    getUploadFile (file) {
      this.form.logo = file
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {
            ...this.form,
          }
          try {
            if (this.form.logo.size) {
              const { key } = await api_postFileUpload(this.form.logo, 'BenefitLogo')
              params.logo = key
            }
            this.$route.query.id ? await api_putMemberBenefit({...params, id: this.$route.query.id}) : await api_postMemberBenefit(params)
            this.$baseMessage('操作成功', 'success')
            this.onBack()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },
    // 获取详情数据
    async getInfo () {
      const data = await api_getMemberBenefit({id: this.$route.query.id})
      let {name, remark, logo} = data
      this.form = {name, remark, logo}
    },
    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.member-equity-create {
  width: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  position: relative;
  padding-bottom: 100px;
  .el-input,
  .el-textarea,
  .el-select {
    width: 350px;
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .optional {
    height: 17px;
    line-height: 17px;
    margin-top: 5px;
    font-size: 12px;
    color: #666666;
  }
  ::v-deep{
    .avatar-uploader{
      height: 152px;
    }
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
